import * as React from 'react';
import {
  useDebouncedEffect,
  type DebounceOptions,
} from '@packages/systems/ui/hooks/useDebouncedEffect';

const baseEquality = (a: any, b: any) => a === b;

export default function useDebouncedValue<ValueType>({
  equalityFn = baseEquality,
  lodashDebounceOptions,
  value,
  wait,
}: {
  equalityFn?: (a: ValueType, b: ValueType) => boolean;
  lodashDebounceOptions?: DebounceOptions;
  value: ValueType;
  wait: number;
}): ValueType {
  const [currentValue, setCurrentValue] = React.useState<ValueType>(value);

  useDebouncedEffect(
    () => {
      if (!equalityFn(value, currentValue)) {
        setCurrentValue(value);
      }
    },
    [value, currentValue],
    wait,
    lodashDebounceOptions
  );

  return currentValue;
}
